import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const handleBriefClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleInfluencerClick = () => {
    navigate('/influencer-kayit');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/88ea9ed6433bf8b3bae03ca6eeceb8bb.jpg"
          alt="NEXIT New Media - AI Powered Agency"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/20"></div>
      </div>

      {/* Elegant Bokeh Lights */}
      <div className="absolute inset-0 z-[1] pointer-events-none overflow-hidden">
        {/* Large soft gold orb - top right */}
        <div
          className="absolute rounded-full"
          style={{
            width: '500px',
            height: '500px',
            top: '-100px',
            right: '-50px',
            background: 'radial-gradient(circle, rgba(212,175,55,0.07) 0%, transparent 70%)',
            animation: 'floatOrb1 12s ease-in-out infinite',
          }}
        />
        {/* Medium orb - bottom left */}
        <div
          className="absolute rounded-full"
          style={{
            width: '350px',
            height: '350px',
            bottom: '80px',
            left: '-60px',
            background: 'radial-gradient(circle, rgba(212,175,55,0.06) 0%, transparent 70%)',
            animation: 'floatOrb2 15s ease-in-out infinite',
          }}
        />
        {/* Small bright orb - center left */}
        <div
          className="absolute rounded-full"
          style={{
            width: '200px',
            height: '200px',
            top: '35%',
            left: '15%',
            background: 'radial-gradient(circle, rgba(255,220,120,0.08) 0%, transparent 70%)',
            animation: 'floatOrb3 10s ease-in-out infinite',
          }}
        />
        {/* Thin horizontal golden line */}
        <div
          className="absolute left-0 right-0"
          style={{
            top: '50%',
            height: '1px',
            background: 'linear-gradient(to right, transparent 0%, rgba(212,175,55,0.12) 30%, rgba(212,175,55,0.18) 50%, rgba(212,175,55,0.12) 70%, transparent 100%)',
          }}
        />
      </div>

      <style>{`
        @keyframes floatOrb1 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(-20px, 30px); }
        }
        @keyframes floatOrb2 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(25px, -20px); }
        }
        @keyframes floatOrb3 {
          0%, 100% { transform: translate(0, 0); }
          33% { transform: translate(15px, -25px); }
          66% { transform: translate(-10px, 15px); }
        }
      `}</style>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 text-center">
        {/* AI Badge */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="inline-flex items-center gap-2 bg-white/8 backdrop-blur-sm border border-white/12 rounded-full px-5 py-2 mb-8"
        >
          <span className="w-2 h-2 bg-[#D4AF37] rounded-full animate-pulse"></span>
          <span className="font-sans text-xs text-white/75 tracking-widest uppercase">New MedIA wIth AI &amp; Real IMPACT!</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="font-sans text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight tracking-tight"
        >
          Premium markalar için
          <br />
          yeni medya.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-lg md:text-xl text-white/75 mb-14 max-w-3xl mx-auto leading-relaxed"
        >
          NEXIT; strateji, içerik, influencer ve yapay zeka ile markaları daha görünür ve daha değerli kılar.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="flex flex-col sm:flex-row items-stretch justify-center gap-0 max-w-2xl mx-auto"
        >
          {/* Markalar için */}
          <div className="flex-1 flex flex-col items-center gap-3 px-8 py-6 bg-white/5 backdrop-blur-sm border border-white/10 rounded-l-xl sm:rounded-r-none rounded-xl sm:rounded-xl">
            <div className="flex items-center gap-2 text-white/60">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-building-2-line text-sm"></i>
              </div>
              <span className="font-sans text-xs tracking-widest uppercase text-white/50">Markalar için</span>
            </div>
            <p className="font-sans text-xs text-white/45 text-center leading-relaxed">
              Kampanya planlamak veya teklif almak için
            </p>
            <button
              onClick={handleBriefClick}
              className="w-full bg-white text-[#1A1A1A] px-6 py-3 rounded-lg font-sans font-medium hover:bg-[#F7F5F0] transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              Toplantı Talep Et / Brief Gönder
            </button>
          </div>

          {/* Dikey ayırıcı */}
          <div className="hidden sm:flex items-center px-0">
            <div className="w-px h-full bg-white/10"></div>
          </div>
          <div className="sm:hidden flex justify-center py-0">
            <div className="h-px w-full bg-white/10"></div>
          </div>

          {/* Influencer'lar için */}
          <div className="flex-1 flex flex-col items-center gap-3 px-8 py-6 bg-white/5 backdrop-blur-sm border border-white/10 rounded-r-xl sm:rounded-l-none rounded-xl sm:rounded-xl">
            <div className="flex items-center gap-2 text-white/60">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-user-star-line text-sm"></i>
              </div>
              <span className="font-sans text-xs tracking-widest uppercase text-white/50">Influencer'lar için</span>
            </div>
            <p className="font-sans text-xs text-white/45 text-center leading-relaxed">
              Premium markalarla çalışmak için ağımıza katıl
            </p>
            <button
              onClick={handleInfluencerClick}
              className="w-full bg-[#D4AF37]/90 text-white px-6 py-3 rounded-lg font-sans font-medium hover:bg-[#D4AF37] transition-all duration-300 whitespace-nowrap cursor-pointer border border-[#D4AF37]/50 text-sm"
            >
              Influencer Ağımıza Kayıt Ol
            </button>
          </div>
        </motion.div>

        {/* Services Strip */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="mt-16 flex flex-wrap items-center justify-center gap-0"
        >
          {[
            { icon: 'ri-line-chart-line', label: 'Strategy' },
            { icon: 'ri-robot-2-line', label: 'AI Content / Production' },
            { icon: 'ri-user-star-line', label: 'Influencer Marketing' },
            { icon: 'ri-vip-crown-line', label: 'Experience' },
            { icon: 'ri-share-circle-line', label: 'Social Media' },
          ].map((item, index, arr) => (
            <div key={item.label} className="flex items-center">
              <div className="flex items-center gap-2 px-5 py-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-xs text-[#D4AF37]/70`}></i>
                </div>
                <span className="font-sans text-xs tracking-wide text-white/45 whitespace-nowrap">{item.label}</span>
              </div>
              {index < arr.length - 1 && (
                <div className="w-px h-4 bg-white/15"></div>
              )}
            </div>
          ))}
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
      >
        <div className="w-6 h-10 border-2 border-white/25 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/35 rounded-full animate-bounce"></div>
        </div>
      </motion.div>
    </section>
  );
}
